import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowDate } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type DocumentGenerationParamsViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  contractEffectiveDateValue?: { displayId: string; id: string } | null;
  contractEffectiveDate: string | null;
  contractEndDateValue?: { displayId: string; id: string } | null;
  contractEndDate: string | null;
};

export const DocumentGenerationParamsViewForm: React.FC<DocumentGenerationParamsViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      contractEffectiveDate = null,
      contractEndDate = null,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupDocumentGenerationParamsLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowDate
                  value={contractEffectiveDate}
                  label={
                    langStore.DocumentGenerationParamsContractEffectiveDateLabel
                  }
                  locale={langStore.timeFormat}
                />
                <ShowDate
                  value={contractEndDate}
                  label={langStore.DocumentGenerationParamsContractEndDateLabel}
                  locale={langStore.timeFormat}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
